import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  query,
  orderBy,
  QueryConstraint,
} from "firebase/firestore";
import { db } from "../../firebase";

// Generic Firestore CRUD yardımcıları (içerik yönetimi sayfaları için).
// Alan adları mobil ile BİREBİR aynı tutulmalı (koleksiyon şemaları mobilden okunuyor).

export interface WithId {
  id: string;
}

// Koleksiyonu oku; opsiyonel orderBy ile sırala.
export async function fetchAll<T>(
  collectionName: string,
  ...constraints: QueryConstraint[]
): Promise<(T & WithId)[]> {
  const q = constraints.length
    ? query(collection(db, collectionName), ...constraints)
    : query(collection(db, collectionName));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...(d.data() as T) }));
}

export async function createDoc<T extends object>(collectionName: string, data: T): Promise<string> {
  const ref = await addDoc(collection(db, collectionName), data);
  return ref.id;
}

export async function updateDocById<T extends object>(
  collectionName: string,
  id: string,
  data: Partial<T>
): Promise<void> {
  await updateDoc(doc(db, collectionName, id), data as any);
}

export async function deleteDocById(collectionName: string, id: string): Promise<void> {
  await deleteDoc(doc(db, collectionName, id));
}

// sira (number) için yeniden export — sayfalarda orderBy('sira','asc') kullanılacak.
export { orderBy };
